var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerCorporationOfIndiaLogoConcor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 270,
    viewBox: "0 0 230 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 270,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7 15C95.9 12 97 10.7 97 7H7L7.2 158H97C97 154.8 95.9 152.6 94.6 150.1C67.1 150.1 50.6 143.8 35.3 128C18.3 110.5 14 77.4 26.1 53C39.9 25.2 63.3 16.8 94.7 15Z",
    fill: "#672A27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2002 181.1C23.7002 188.3 19.6002 187 41.0002 187L40.8002 195.7C19.6002 182.6 15.6002 216.1 40.6002 205.7V215.7L48.5002 217.9L48.6002 203C51.0002 201.2 53.5002 199.1 57.8002 200.1C59.1002 204.5 55.6002 207.9 53.9002 210.8L60.0002 213C62.1002 209.2 65.5002 204.4 61.3002 199.3C58.0002 195.2 54.6002 194.6 48.6002 196.2L48.7002 187.1L70.3002 187V214.2L77.9002 217.9L78.0002 187.1H107.9L108 196.8C102.3 196.9 87.8002 195.3 84.8002 198.6C85.0002 200.3 90.0002 208.3 95.6002 207.4L96.0002 202.6H107.9L108 214.2L115.6 218V187.1L139.8 187.2V195.8C136.9 193.9 134.3 191.9 129.1 193C115.4 195.8 123.3 214.4 139.4 205.8L139.5 215.8L147.3 217.8L147.4 202.6C149.3 201.9 149.5 201.2 151.4 200.4L156.5 200.6C158.2 204.2 154.2 207.8 152.8 210.2L154 211.2C154.1 211.3 154.3 211.4 154.4 211.5C166 218.6 164.8 189.4 147.3 196.3L147.4 187.1L169 187.3L169.1 214.5C172.3 215.3 173.6 217.3 176.6 217.8L176.8 187.1H194.8L194.6 197.2C191.9 196.1 190 195.7 187.8 197.3C184.2 201.7 193.6 207 195.4 208.9C198 211.5 198.4 211.8 200.8 213.8C203.3 215.9 203.4 217.3 206.4 218.6L208.9 216.9C208.1 215.1 200.4 208.3 198.4 206.6C201.2 204.1 202.3 205 202.6 199.3C202.8 195.2 202.4 191.2 202.8 187.1L212.8 187L209.1 181.3L19.2002 181.1ZM40.8002 198.9C40.3002 201.2 39.4002 202.1 35.4002 203.3C25.0002 206.5 27.4002 193.2 40.8002 198.9ZM128.4 203.2C125.4 196.4 136.9 195.6 139.5 199.8C138.7 201.3 138.8 201.9 134.5 203.2C132.1 204 130.6 204.2 128.4 203.2Z",
    fill: "#221D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7002 83.1999C43.8002 84.8999 53.4002 98.1999 55.8002 98.7999H90.9002C89.6002 96.2999 87.9002 95.0999 86.7002 92.4999L126 92.2999C125 90.0999 123.4 88.6999 122.3 86.1999H223.6V77.2999L44.9002 77.3999L40.7002 83.1999Z",
    fill: "#1F8CDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 101.5L65.9 111C67.4 112.9 68.4 113.7 70.1 115.7C74.8 121.1 75.3 123.1 80.4 123H106.5C105.3 119.7 104.1 120.2 102.6 116.7L141.7 116.6C140.8 114.8 138.6 112.1 138.1 110.4H223.9L223.4 101.5H58Z",
    fill: "#1F8CDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3999 71.7999L79.7999 71.8999C84.7999 71.8999 84.9999 72.4999 88.0999 69.8999C94.3999 64.4999 92.9999 65.8999 103.8 65.8999C110.2 65.8999 117.5 66.1999 123.8 65.7999C125 63.5999 126.4 62.0999 128.5 59.9999L224 59.8999L223.9 51.3999C177.5 52.2999 125.9 51.4999 78.5999 51.3999C66.1999 51.3999 70.1999 48.8999 56.0999 64.9999C54.5999 66.5999 51.0999 70.2999 50.3999 71.7999Z",
    fill: "#1F8CDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5996 125.9L87.2996 135C98.4996 149.2 97.8996 147.5 106.5 147.5C111.6 147.5 117.1 147.7 122.2 147.4C121.3 145.2 119.5 143.8 118 141.2L157.4 141.1L153.6 134.9H223.8V125.9H79.5996Z",
    fill: "#1F8CDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0996 48.5L98.2996 48.7C103.9 48.7 103.9 46 107.2 43.9C110.1 42 130.4 43 135.3 43C142.1 43 139.8 40.3 143.9 37.4L223.7 37.2V29H88.0996L71.0996 48.5Z",
    fill: "#1F8CDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 25.9C95.1 26.8 103.3 26.2 107.8 26.2C117.5 26.2 115.5 27.4 121.4 22.6C127.2 17.8 150 21.9 154.3 20.3C160.4 15.6 154.8 14.6 166.6 14.6H223.7V7H107.6L91 25.9Z",
    fill: "#1F8CDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.2 150.2C103 152.4 105.7 157.6 109.2 158C113.3 158.5 121.1 158 125.6 158C137.6 158 219.3 158.7 223.8 157.7L223.6 150.1L101.2 150.2Z",
    fill: "#1F8CDB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0998 167.5C76.3998 169.3 73.2998 173.7 68.1998 173.3C62.9998 172.9 62.1998 168.5 58.8998 167.2L57.2998 168.4C58.5998 179.8 80.0998 182 83.7998 171L79.0998 167.5Z",
    fill: "#221D1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.3 167.6C176.8 168.3 165.1 180.6 158.4 166.8L155.9 169.1C160.6 181.5 178.4 180.9 182.3 171.2C180.5 169.1 180.1 169.1 178.3 167.6Z",
    fill: "#221D1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2996 245.6L102.4 261.5L114.3 261.6L114.4 228.1L103 228.2L102.7 244.9L95.8996 228.2L83.5996 228.4V261.4L94.9996 261.6L95.2996 245.6Z",
    fill: "#221D1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.5 234.5C195.8 234.5 196.1 234.5 196.3 234.5C203.2 235 203.1 244.3 196.3 244.3C196 244.3 195.7 244.3 195.5 244.3C195.5 241 195.5 237.7 195.5 234.5ZM205.7 247C208.8 244.7 212 244.3 212.8 239.8C213.5 235.3 210.9 232.4 208.7 230.9C202.8 226.9 190.5 228.1 182.8 228V261.5L195.3 261.4L195.7 249.4L200.8 261.5L214.2 261.4L205.7 247Z",
    fill: "#221D1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.3 251.2C185.5 224.3 151.6 220.4 146.4 238.5C143.2 249.5 147.9 259 156.4 261.5C167 264.5 176.1 259.6 178.3 251.2ZM164.8 253.2C158.5 254.4 158.2 250.5 158.2 244.3C158.3 238.3 158.8 234.9 164.8 236.1C167.2 240.5 167.1 248.8 164.8 253.2Z",
    fill: "#221D1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4999 247.7C47.2999 257.9 54.9999 263.2 66.0999 262C75.9999 260.9 80.4998 253 79.6998 242.3C78.8998 232 71.2999 226.2 59.9999 227.6C49.7999 229 45.5999 236.7 46.4999 247.7ZM65.4999 236.1C72.9999 252.3 57.2999 263.8 58.9999 241.5C59.3999 236.5 60.8999 235.1 65.4999 236.1Z",
    fill: "#221D1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8 252.9C36.6 254.3 31.9 253.4 31.8 245C31.6 235.4 36.2 235.9 44 236C43.8 230.3 45.7 228.3 40.2 227.7C8.29999 223.9 14.2 271.2 43.9 261L43.8 252.9Z",
    fill: "#221D1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.4 253C135.6 253.9 131 253.5 131.2 244.3C131.4 235.7 135.7 235.2 143.4 236.2V228.6C129.8 224.6 118.1 231.8 118.2 245.1C118.3 261.1 135.2 264.6 143.3 261L143.4 253Z",
    fill: "#221D1F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4999 236.1C60.8999 235.1 59.3999 236.5 58.9999 241.5C57.2999 263.9 72.9999 252.3 65.4999 236.1Z",
    fill: "#FCFCFC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.8 253.2C167.1 248.8 167.2 240.4 164.8 236.1C158.8 234.9 158.3 238.3 158.2 244.3C158.2 250.5 158.5 254.4 164.8 253.2Z",
    fill: "#FCFCFC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.4 203.2C130.6 204.2 132.1 204 134.5 203.2C138.8 201.9 138.7 201.3 139.5 199.8C136.9 195.6 125.4 196.4 128.4 203.2Z",
    fill: "#FCFCFC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8002 198.9C27.4002 193.2 25.0002 206.5 35.4002 203.3C39.3002 202.1 40.2002 201.3 40.8002 198.9Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerCorporationOfIndiaLogoConcor);
export default __webpack_public_path__ + "static/media/container-corporation-of-india-logo-concor.27acc09afdf913d7a280614797bd0c46.svg";
export { ForwardRef as ReactComponent };